import { render, staticRenderFns } from "./settings-company.vue?vue&type=template&id=63a88ae6&lang=html&"
import script from "./settings-company.vue?vue&type=script&lang=js&"
export * from "./settings-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports